import React from 'react';
import classnames from 'classnames';

import styles from './option-button.scss';

const OptionButton = ({onClick, children, className, style, wide, openRight}) => (

  <button
    className={classnames(
      className,
      wide ? styles.wide : styles.regular,
      openRight ? styles.openRight : styles.openLeft
    )}
    onClick={() => onClick()}
    style={style}
    type="button"
  >
    {children}
  </button>
);

OptionButton.propTypes = {
  className: React.PropTypes.string,
  style: React.PropTypes.object,
  children: React.PropTypes.string,
  onClick: React.PropTypes.func,
  wide: React.PropTypes.bool,
  openRight: React.PropTypes.bool
};

export default OptionButton;



// WEBPACK FOOTER //
// ./src/components/dropdown/option-button.jsx